import React, { Component } from "react";
import Select from "react-select";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { Alert, Button, Col, Row, Form, Table } from "react-bootstrap-v5";
import * as JobOptions from "../../../../Function/defaultJobOptions";
import AutoComplete from "../../../AutoComplete";
import EnquiryService from "../../../../Services/EnquiryService";
import { toast } from "react-toastify";

const DECIMALLENGTH = 3;

class Shipment extends Component {
  constructor() {
    super();
    this.state = {
      originData: {},
      destinationData: {},
      serviceTypeValue: null,
      shipmentValue: null,
      quoteValue: null,
      shipmentData: {},
    };
  }

  componentDidMount() {
    const { jobData } = this.props;

    jobData.origin === "" &&
      this.getPlaceData("Dubai").then((e) => {
        let setOri = {
          origin_country: e.country,
          origin_country_short_name: e.country_short_name,
          origin_city: e.city,
          origin_latitude: e.latitude,
          origin_longitude: e.longitude,
        };

        this.setState(() => {
          return { originData: setOri };
        });
        this.props.handleOringDestination(
          { origin: "Dubai", origin_country: "United Arab Emirates" },
          "shipment_details"
        );
        // this.props.onChangeValue({value: 'Dubai'}, 'shipment_details', 'origin')
        // this.props.onChangeValue({value: 'United Arab Emirates'}, 'shipment_details', 'origin_country')
        this.props.handleChangeOrgDest("originData", setOri);
      });

    this.setState(() => {
      return { shipmentData: JSON.parse(JSON.stringify(jobData)) };
    });
  }

  setData() {
    const { serviceTypeValue, shipmentValue } = this.state;
    const { jobData } = this.props;

    if (
      jobData !== undefined &&
      (serviceTypeValue === null || shipmentValue === null)
    ) {
      let serviceTp = "NONE",
        shipTp = "NONE";
      if (jobData.servic_type.includes("DOOR")) {
        serviceTp = "DOOR";
      }
      if (jobData.servic_type.includes("CONSOLIDATION")) {
        serviceTp = "CONSOLIDATION";
      }
      if (jobData.servic_type === "PORT") {
        serviceTp = "PORT";
      }

      if (jobData.shipment_mode.includes("AIR")) {
        shipTp = "AIR";
      }
      if (jobData.shipment_mode.includes("SEA")) {
        shipTp = "SEA";
      }
      if (jobData.shipment_mode.includes("COURIER")) {
        shipTp = "COURIER";
      }
      if (jobData.shipment_mode.includes("LAND")) {
        shipTp = "LAND";
      }

      this.setState({ serviceTypeValue: serviceTp, shipmentValue: shipTp });
    }
  }

  handleInputChnage = (e, type) => {
    if (type === "servic_type") {
      this.setState({ serviceTypeValue: e.value }, () => {
        this.setServiceShipment(type);
      });
    }

    if (type === "shipment_mode") {
      this.setState({ shipmentValue: e.value }, () => {
        this.setServiceShipment(type);
      });
    }
  };

  setServiceShipment = (type) => {
    let ssValue;

    ssValue = {
      value: this.state.serviceTypeValue.concat(this.state.shipmentValue),
    };

    this.props.onChangeValue(ssValue, "shipment_details", "servic_type");
    this.props.onChangeValue(ssValue, "shipment_details", "shipment_mode");
    this.props.handleResetAddOnPayment(); // Reset payment and add on
  };

  setQuoteValue = (value) => {
    this.setState({ quoteValue: value });
  };

  getQuote = () => {
    const { jobData } = this.props;

    if (jobData.servic_type === "") return false;

    jobData &&
      jobData.origin &&
      this.getPlaceData(jobData.origin)
        .then((e) => {
          let setOri = {
            origin_country: e.country,
            origin_country_short_name: e.country_short_name,
            origin_city: e.city,
            origin_latitude: e.latitude,
            origin_longitude: e.longitude,
          };

          this.setState({ originData: setOri }, this.setBookingAmt);
        })
        .catch((error) => console.log(error));

    jobData &&
      jobData.destination &&
      this.getPlaceData(jobData.destination).then((e) => {
        let setOri = {
          origin_country: e.country,
          origin_country_short_name: e.country_short_name,
          origin_city: e.city,
          origin_latitude: e.latitude,
          origin_longitude: e.longitude,
        };

        this.setState({ destinationData: setOri }, this.setBookingAmt);
      });
  };

  setBookingAmt = () => {
    const { originData, destinationData } = this.state;
    const { jobData, jobItems, quoteToken } = this.props;

    if (
      jobItems[0]["actual"]["no_of_pkgs"] === 0 ||
      jobItems[0]["booking"]["no_of_pkgs"] === 0
    ) {
      toast.error("Please check Items, may be they are empty");
      return false;
    }

    if (
      Object.keys(originData).length === 0 ||
      Object.keys(destinationData).length === 0
    ) {
      return false;
    }
    let tempCopy = JSON.parse(JSON.stringify(jobItems));

    // separate actual items data
    let actualItemOriginal =
      tempCopy.length && tempCopy.map((item) => item.actual);

    let totalPackages = actualItemOriginal.reduce(
      (total, item) => Number(item.no_of_pkgs) + total,
      0
    );

    let totalVolume = actualItemOriginal.reduce(
      (total, item) => Number(item.total_volume_CBM) + total,
      0
    );

    let totalWeight = actualItemOriginal.reduce(
      (total, item, currIndex) => Number(item.total_weight_KG) + total,
      0
    );

    let shipType =
      jobData.service_type === undefined
        ? jobData.shipment_mode
        : jobData.service_type.concat(jobData.shipment_mode);

    let items = actualItemOriginal.map((item, idx) => {
      return {
        item_id: "",
        item_description: item.item_description,
        no_of_pkgs: item.no_of_pkgs,
        dimension: {
          kilogram: item.kilogram,
          length: item.length,
          width: item.width,
          height: item.height,
        },

        total_volume_CBM: item.total_volume_CBM,
        total_weight_KG: item.total_weight_KG,
        item_token: jobItems[idx].item_token,
      };
    });

    let postData = {
      origin_country: originData.origin_country,
      origin_country_short_name: originData.origin_country_short_name,
      origin_city: originData.origin_city,
      origin_latitude: originData.origin_latitude,
      origin_longitude: originData.origin_longitude,
      destination_country: destinationData.origin_country,
      destination_country_short_name: destinationData.origin_country_short_name,
      destination_city: destinationData.origin_city,
      destination_latitude: destinationData.origin_latitude,
      destination_longitude: destinationData.origin_longitude,

      number_of_packages: totalPackages,
      volume: Number(totalVolume.toFixed(DECIMALLENGTH)),
      weight: Number(totalWeight.toFixed(DECIMALLENGTH)),
      items_goods: Number(jobData.value_of_goods),

      items: items,
      quote_token: quoteToken,
      referral_token: "",
      promo_code: "",
    };

    let getFinalQuotezKey;
    let sType = jobData.hasOwnProperty("servic_type")
      ? jobData.servic_type
      : jobData.service_type;

    if (sType.includes("PORT")) getFinalQuotezKey = "port_delivery";
    if (sType.includes("DOOR")) getFinalQuotezKey = "door_delivery";
    if (sType.includes("CONSOLIDATION"))
      getFinalQuotezKey = "consolidation_delivery";

    let k = getFinalQuotezKey.replace("_delivery", "");

    shipType.includes("AIR") &&
      EnquiryService.postCheckAirQuote(postData).then((result) => {
        if (result.status === true) {
          let inputData = {
            name: "booking_amount",
            value:
              result.all_data.final[getFinalQuotezKey][
                `discount_${k}_grant_total`
              ],
          };

          this.setQuoteValue(inputData.value);
        }
      });

    shipType.includes("SEA") &&
      EnquiryService.postCheckSeaQuote(postData).then((result) => {
        if (result.status === true) {
          let inputData = {
            name: "booking_amount",
            value:
              result.all_data.final[getFinalQuotezKey][
                `discount_${k}_grant_total`
              ],
          };

          this.setQuoteValue(inputData.value);
        }
      });

    shipType.includes("COURIER") &&
      EnquiryService.postCheckCourierQuote(postData).then((result) => {
        if (result.status === true) {
          let inputData = {
            name: "booking_amount",
            value:
              result.all_data.final.door_delivery.discount_door_grant_total,
          };

          this.setQuoteValue(inputData.value);
        }
      });

    shipType.includes("LAND") &&
      EnquiryService.postCheckLandQuote(postData).then((result) => {
        if (result.status === true) {
          let inputData = {
            name: "booking_amount",
            value:
              result.all_data.final[getFinalQuotezKey][
                `discount_${k}_grant_total`
              ],
          };

          this.setQuoteValue(inputData.value);
        }
      });
  };

  setOriginData = (e) => {
    this.setState({
      originData: {
        origin_country: e.country,
        origin_country_short_name: e.country_short_name,
        origin_city: e.city,
        origin_latitude: e.latitude,
        origin_longitude: e.longitude,
      },
    });

    if (e.city) {
      // this.props.onChangeValue({ value: e.city }, 'shipment_details', 'origin')
      // this.props.onChangeValue({ value: e.country }, 'shipment_details', 'origin_country')
      this.props.handleOringDestination(
        { origin: e.city, origin_country: e.country },
        "shipment_details"
      );
      this.props.handleChangeOrgDest("originData", this.state.originData);
    }
  };

  setDesitinationData = (e) => {
    this.setState(() => {
      return {
        destinationData: {
          origin_country: e.country,
          origin_country_short_name: e.country_short_name,
          origin_city: e.city,
          origin_latitude: e.latitude,
          origin_longitude: e.longitude,
        },
      };
    });

    if (e.city) {
      // this.props.onChangeValue({ value: e.city }, 'shipment_details', 'destination')
      // this.props.onChangeValue({ value: e.country }, 'shipment_details', 'destination_country')
      this.props.handleOringDestination(
        { destination: e.city, destination_country: e.country },
        "shipment_details"
      );
      this.props.handleChangeOrgDest(
        "destinationData",
        this.state.destinationData
      );
      this.props.handleResetAddOnPayment(); // Reset payment and add on
    }
  };

  getPlaceData = (address) => {
    return geocodeByAddress(address).then((results) => {
      const contrypick = results[0].address_components.filter(
        (item) => item.types.indexOf("country") >= 0
      );
      const citypick = results[0].address_components.filter(
        (item) =>
          item.types.indexOf("locality") >= 0 ||
          item.types.indexOf("administrative_area_level_1") >= 0
      );

      return getLatLng(results[0]).then((latlngRes) => {
        let pl = {
          country: contrypick[0].long_name,
          country_short_name: contrypick[0].short_name,
          city: citypick[0].long_name,
          latitude: latlngRes.lat,
          longitude: latlngRes.lng,
        };

        return pl;
      });
    });
  };

  applyQuoteToActual = () => {
    const { shipmentData } = this.state;
    const { paymentInformation, jobData } = this.props;

    if (
      jobData.servic_type !== shipmentData.servic_type ||
      jobData.shipment_mode !== shipmentData.shipment_mode ||
      jobData.destination !== shipmentData.destination ||
      jobData.value_of_goods !== shipmentData.value_of_goods
    ) {
      this.setState({ show: true });
    }

    this.props.onChangeValue(
      { value: this.state.quoteValue },
      "payment_information",
      "actual_amount"
    );
    this.props.onChangeValue(
      { value: this.state.quoteValue },
      "payment_information",
      "booking_amount"
    );
    this.props.onChangeValue(
      { value: this.state.quoteValue },
      "payment_information",
      "freight"
    );

    if (Object.keys(paymentInformation).length !== 0) {
      let breakdown = paymentInformation.breakdown;
      breakdown.freight = this.state.quoteValue;
      this.props.onChangeValue(
        { value: breakdown },
        "payment_information",
        "breakdown"
      );
    }
  };

  ShowAlert = () => {
    if (this.state.show) {
      return (
        <Alert
          variant="warning"
          onClose={() => this.setState({ show: false })}
          dismissible
        >
          <Alert.Heading>Warning!</Alert.Heading>
          <p>Message goes here</p>
          <hr />
          <div className="d-flex justify-content-end">
            <Button
              onClick={() => this.setState({ show: false })}
              variant="outline-warning"
            >
              Close me y'all!
            </Button>
          </div>
        </Alert>
      );
    }
  };

  checkIsNotLocal = () => {
    let shipmentTypeLocal = [
      "LOCAL_MOVING",
      "LOCAL_TRANSPORT",
      "LOCAL_PACKING",
      "DOCUMENTATION",
      "OTHER_SERVICES",
    ];
    if (shipmentTypeLocal.includes(this.state.shipmentData.shipment_type)) {
      return false;
    } else if (
      ["OTHER", "LOCAL", "OTHERLOCAL"].includes(
        this.state.shipmentData.servic_type
      )
    ) {
      return false;
    } else if (
      ["OTHER", "LOCAL", "OTHERLOCAL"].includes(
        this.state.shipmentData.shipment_mode
      )
    ) {
      return false;
    }
    return true;
  };

  
  render() {
    const { originData, destinationData, quoteValue, shipmentData } =
    this.state;
    const { jobData, formValidator, jobItems, schedulePickup, orderId } = this.props;
    if (!jobData || Object.keys(jobData).length === 0) return false;
    this.setData();
    const shipmentAssormentObj = {
      NOT_RECEIVED : {
        value: "NOT_RECEIVED",
        label: "Not Received",
      },
      PARTIAL_RECEIVED : {
        value: "PARTIAL_RECEIVED",
        label: "Partial Received",
      },
      RECEIVED : {
        value: "RECEIVED",
        label: "Received",
      }
    }
    
    return (
      <div className="card">
        <div className="card-header bg-light">
          <h4>Shipment Information</h4>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="mb-3 col-md-4 col-12">
              <div className="mb-3">
                <label className="form-label">Service</label>
                <Select
                  options={JobOptions.serviceType()}
                  name="service_type"
                  value={
                    jobData.servic_type.includes("DOOR")
                      ? { value: "DOOR", label: " Door to Door - Direct" }
                      : jobData.servic_type.includes("CONSOLIDATION")
                      ? {
                          value: "CONSOLIDATION",
                          label: "Door to Door - Consolidation",
                        }
                      : jobData.servic_type === "NONE"
                      ? { value: "NONE", label: "Select" }
                      : jobData.servic_type.includes("PORT")
                      ? { value: "PORT", label: "Door to Port" }
                      : jobData.servic_type.includes("OTHER")
                      ? { value: "OTHER", label: "Other Service" }
                      : ""
                  }
                  onChange={(e) => this.handleInputChnage(e, "servic_type")}
                />
                {
                  // formValidator.message('service type', jobData.shipment_type, 'required', { className: 'text-danger' })
                }
              </div>

              <div className="mb-3">
                <label className="form-label">Shipment Type</label>
                <Select
                  options={JobOptions.shipmentType()}
                  name="shipment_type"
                  value={JobOptions.shipmentType().filter(
                    (obj) => obj.value === jobData.shipment_type
                  )}
                  onChange={(e) =>
                    this.props.onChangeValue(
                      e,
                      "shipment_details",
                      "shipment_type"
                    )
                  }
                />
                {
                  // formValidator.message('Shipment type', jobData.shipment_type, 'required', { className: 'text-danger' })
                }
              </div>
            </div>

            <div className="mb-3 col-md-4 col-12">
              <div className="mb-3">
                <label className="form-label">Shipping Mode</label>
                <Select
                  options={JobOptions.shippingMode()}
                  name="shipment_mode"
                  value={
                    jobData.shipment_mode.includes("AIR")
                      ? { value: "AIR", label: "Air Frt" }
                      : jobData.shipment_mode.includes("SEA")
                      ? { value: "SEA", label: "Sea Frt" }
                      : jobData.shipment_mode.includes("COURIER")
                      ? { value: "COURIER", label: "Courier" }
                      : jobData.shipment_mode.includes("LAND")
                      ? { value: "LAND", label: "Land Frt" }
                      : jobData.shipment_mode.includes("NONE")
                      ? { value: "NONE", label: "Select" }
                      : jobData.shipment_mode.includes("LOCAL")
                      ? { value: "LOCAL", label: "Local" }
                      : ""
                  }
                  onChange={(e) => this.handleInputChnage(e, "shipment_mode")}
                />
                {
                  // formValidator.message('shipping mode', jobData.shipment_mode, 'required', { className: 'text-danger' })
                }
              </div>

              <div className="mb-3">
                <label className="form-label">Value of Goods (AED)</label>
                <input
                  className="form-control form-control-sm"
                  name="value_of_goods"
                  value={jobData.value_of_goods}
                  onChange={(e) =>
                    this.props.onChangeValue(e, "shipment_details")
                  }
                />
                {
                  // formValidator.message('value of goods', jobData.value_of_goods, 'required', { className: 'text-danger' })
                }
              </div>
            </div>

            <div className="mb-3 col-md-4 col-12">
              <div className="mb-3">
                <label className="form-label">Origin</label>

                {/* <input
                                    className="form-control form-control-sm"
                                    name="value_of_goods"
                                    value={jobData.origin}
                                    readOnly
                                /> */}

                <AutoComplete
                  value={jobData.origin + ", " + jobData.origin_country}
                  prefillState={{
                    city: jobData.origin,
                    country: jobData.origin_country,
                  }}
                  getData={(e) => this.setOriginData(e)}
                />

                {
                  // formValidator.message('origin', jobData.origin, 'required', { className: 'text-danger' })
                }
              </div>

              <div className="mb-3">
                <label className="form-label">Destination</label>

                <AutoComplete
                  value={jobData.destination}
                  prefillState={{
                    city: jobData.destination,
                    country: jobData.destination_country,
                  }}
                  getData={(e) => this.setDesitinationData(e)}
                />

                {
                  // formValidator.message('destination', jobData.destination, 'required', { className: 'text-danger' })
                }
              </div>
            </div>

            <div className="col-12 d-flex mt-2">
              <div className="col-8">
                <div className="card p-0">
                  <div className="card-header bg-light text-center">
                    <h6 className="mb-0">INSURANCE</h6>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4">
                        <div className="row">
                          <label className="form-label">OPTED</label>
                          <div key={`inline-radio`} className="mb-3">
                            <Form.Check
                              inline
                              label="Yes"
                              name="insurance_opted"
                              value="yes"
                              type="radio"
                              id={`inline-radio-1`}
                              checked={jobData.insurance_opted === "yes"}
                              // value={jobData.insurance_opted}
                              onChange={(e) =>
                                this.props.onChangeValue(e, "shipment_details")
                              }
                            />
                            <Form.Check
                              inline
                              label="No"
                              name="insurance_opted"
                              value="no"
                              type="radio"
                              id={`inline-radio-2`}
                              checked={jobData.insurance_opted === "no"}
                              //   value={jobData.insurance_opted}
                              onChange={(e) =>
                                this.props.onChangeValue(e, "shipment_details")
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="row">
                          <label className="form-label">APPLIED</label>
                          <div key={`inline-radio`} className="mb-3">
                            <Form.Check
                              disabled={jobData.insurance_opted !== "yes"}
                              inline
                              label="Yes"
                              name="insurance_applied"
                              value="yes"
                              type="radio"
                              id={`inline-radio-1`}
                              // value={jobData.insurance_applied}
                              checked={
                                jobData.insurance_applied === "yes" &&
                                jobData.insurance_opted === "yes"
                              }
                              onChange={(e) =>
                                this.props.onChangeValue(e, "shipment_details")
                              }
                            />
                            <Form.Check
                              disabled={jobData.insurance_opted !== "yes"}
                              inline
                              label="No"
                              name="insurance_applied"
                              value="no"
                              type="radio"
                              id={`inline-radio-2`}
                              // value={jobData.insurance_applied}
                              checked={
                                jobData.insurance_applied === "no" &&
                                jobData.insurance_opted === "yes"
                              }
                              onChange={(e) =>
                                this.props.onChangeValue(e, "shipment_details")
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="row">
                          <label className="form-label">POLICY RECEIVED</label>
                          <div key={`inline-radio`} className="mb-3">
                            <Form.Check
                              disabled={jobData.insurance_applied !== "yes"}
                              inline
                              label="Yes"
                              name="insurance_policy_received"
                              value="yes"
                              type="radio"
                              id={`inline-radio-1`}
                              // value={jobData.insurance_policy_received}
                              checked={
                                jobData.insurance_policy_received === "yes" &&
                                jobData.insurance_applied === "yes"
                              }
                              onChange={(e) =>
                                this.props.onChangeValue(e, "shipment_details")
                              }
                            />
                            <Form.Check
                              disabled={jobData.insurance_applied !== "yes"}
                              inline
                              label="No"
                              name="insurance_policy_received"
                              value="no"
                              type="radio"
                              id={`inline-radio-2`}
                              // value={jobData.insurance_policy_received}
                              checked={
                                jobData.insurance_policy_received === "no" &&
                                jobData.insurance_applied === "yes"
                              }
                              onChange={(e) =>
                                this.props.onChangeValue(e, "shipment_details")
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {schedulePickup?.pickup[0]?.shpt_receipt_assorment && (
              <div className="col-12 d-flex mt-2">
                <div className="col-10">
                  <div className="card p-0">
                    <div className="card-header bg-light text-center">
                      <h6 className="mb-0">Marketplace Shipment status</h6>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <Table striped bordered hover>
                          <thead>
                            <tr>
                              <th rowSpan="2">Order ID</th>
                              <th rowSpan="2">Seller Order ID</th>
                              <th rowSpan="2">Seller Name</th>
                              <th rowSpan="2">Shipment Receipt Assorment</th>
                            </tr>
                          </thead>
                          <tbody>
                            {schedulePickup?.pickup &&
                              schedulePickup?.pickup.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    {index===0 && <td rowSpan={schedulePickup.pickup.length} >{orderId || "-"}</td>}
                                    <td>{item?.seller_order_id || "-"}</td>
                                    <td>{item?.full_name || "-"}</td>
                                    <td>
                                      <Select
                                        options={JobOptions.shipmentAssorment()}
                                        name="shpt_receipt_assorment"
                                        value={
                                          shipmentAssormentObj[item?.shpt_receipt_assorment || "NOT_RECEIVED"]
                                        }
                                        onChange={(e) =>
                                          this.props.handleSelect(
                                            e,
                                            "schedule_pickup",
                                            "shpt_receipt_assorment",
                                            index
                                          )
                                        }
                                      />
                                    


                                      {
                                        // formValidator.message('service type', jobData.shipment_type, 'required', { className: 'text-danger' })
                                      }
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="col-12">
              <div className="">
                <label className="form-label">Comment</label>
                <textarea
                  className="form-control form-control-sm"
                  name="comments"
                  value={jobData.comments}
                  onChange={(e) =>
                    this.props.onChangeValue(e, "shipment_details")
                  }
                />
              </div>
            </div>
          </div>

          <Row>
            <Col className="mt-3">
              {this.checkIsNotLocal() && (
                <Button
                  variant="info"
                  onClick={() => this.getQuote()}
                  size="sm"
                >
                  Get Quotes
                </Button>
              )}
            </Col>

            <Col className="mt-3">
              {quoteValue && (
                <>
                  <span> Price of Quote: {quoteValue} </span>
                  <span>
                    {" "}
                    <Button
                      variant="info"
                      onClick={() => this.applyQuoteToActual()}
                      size="sm"
                    >
                      Apply
                    </Button>{" "}
                  </span>
                </>
              )}
            </Col>
          </Row>

          <Row>
            <Form.Text muted>Set packing again on destination change</Form.Text>
          </Row>
          {/* {this.ShowAlert()} */}
        </div>
      </div>
    );
  }
}

export default Shipment;
